import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { AuthService } from 'src/app/nutrigenic/services/auth/auth.service';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  styleUrls: ['./forgot-password-dialog.component.scss']
})
export class ForgotPasswordDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() switchToLogin = new EventEmitter<void>();

  forgotEmail = '';

  constructor(private authService: AuthService) {}

  handleHide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.switchToLogin.emit();
  }

  requestChangePassword() {
    if (this.forgotEmail != '') {
      this.authService.requestChangePassword({ email: this.forgotEmail }).subscribe({
        next: () => {
          this.visible = false;
          this.visibleChange.emit(false);
          Notify.success('Password reset mail sent', { position: 'right-top', timeout: 3000 });
        },
        error: () => {
          Notify.failure('User not found', { position: 'right-top', timeout: 3000 });
        }
      });
    }
  }
}
